import { ApolloProvider } from '@apollo/client';
import { ConfirmationProvider } from '~/design-system';
import React from 'react';
import { ThemeProvider } from 'theme-ui';

import { PostHogProvider } from 'posthog-js/react';

// create an instance Mixpanel object using your project token
import createClient from './apolloClient';
// import BottlebooksCommonProviders from '@bottlebooks/react-common/src/Providers/BottlebooksCommonProviders';
import theme from '../theme';
import UserLocaleProvider from './UserLocaleProvider';
import { FileAttachmentProvider } from '../components/SmartImportPicker/FileAttachmentContext';

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  disable_session_recording: !import.meta.env
    .VITE_PUBLIC_POSTHOG_ENABLE_CAPTURE,
  cross_subdomain_cookie: true,
  capture_pageview: true,
  integrations: {
    crispChat: true,
  }
};
export default function ImportProviders({ children }) {
  // console.log(theme);
  // Handle when users somehow get access to the wrong domain.
  // Inform the user instead of doing magic redirects.
  if (window.location.origin.includes('bbimports.netlify.app'))
    return (
      <div>
        <span>
          This is not a valid domain. Please use{' '}
          <a href="https://imports.bottlebooks.me">imports.bottlebooks.me</a>{' '}
          instead.
        </span>
      </div>
    );
  return (
    // <BottlebooksCommonProviders>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={posthogOptions}
    >
      <ThemeProvider theme={theme}>
        <ApolloProvider client={createClient()}>
          <UserLocaleProvider>
            <ConfirmationProvider>
              <FileAttachmentProvider>{children}</FileAttachmentProvider>
            </ConfirmationProvider>
          </UserLocaleProvider>
        </ApolloProvider>
      </ThemeProvider>
    </PostHogProvider>
    // </BottlebooksCommonProviders>
  );
}

// function SetLocale() {
//   /** @type {{params:{locale?: string}}}  */
//   const match = useRouteMatch('/:locale');
//   const locale = supportedLocale(match?.params?.locale);
//   return <SwitchLocale locale={locale} />;
// }
